import { createFileRoute } from '@tanstack/react-router'
import { WeekdayCompanies } from '@/features/admin/weekday-companies'

export const Route = createFileRoute(
  '/_authenticated/admin/weekday-companies'
)({
  component: WeekdayCompanies,
})
